<script setup lang="ts">
import ProductPage from '@/components/ProductPage.vue';
import { type Product, getProductById } from '@/lib/shopify/product.ts';
import { useSeoMeta } from '@unhead/vue';
import { useData } from 'vike-vue/useData';
import { onMounted, ref } from 'vue';

const CHARGER_ID = 'gid://shopify/Product/8322259812574';

const data = useData<{ product?: Product }>();
const product = ref<Product | null>(data.product ?? null);

onMounted(async () => {
  if (!product.value) product.value = await getProductById(CHARGER_ID);
});

useSeoMeta({
  title: () => (product.value?.title ? `${product.value.title} - Parsec Skateboards` : 'Parsec Skateboards'),
});
</script>

<template>
  <ProductPage v-if="product" :product />
</template>
